__turbopack_context__.v({
  "backdrop": "drawer-module-scss-module__5IkhAa__backdrop",
  "content": "drawer-module-scss-module__5IkhAa__content",
  "default-header-content": "drawer-module-scss-module__5IkhAa__default-header-content",
  "drawer": "drawer-module-scss-module__5IkhAa__drawer",
  "footer": "drawer-module-scss-module__5IkhAa__footer",
  "header": "drawer-module-scss-module__5IkhAa__header",
});
